import React from "react";

export default function Phonetic({ phonetic }) {
  return (
    <div className="Phonetic">
      <span>/{phonetic}/</span>
    </div>
  );
}
